require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
module.exports = require('../../modules/$.core').Symbol;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/symbol/index.js
// module id = 785
// module chunks = 259